/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

const rutas = [
    {
        path: "/areas",
        name: "Área de carreras",
        view: "areas/index",
        mete: {
            requiresAuth: true
        }
    },
    {
        path: "/areas/:id/carreras",
        name: "carreraGenerica",
        view: "areas/areaCarreras",
        mete: {
            requiresAuth: true
        }
    },
    {
        path: "/areas/carreras/:id/carrerasSede",
        name: "carrerasSede",
        view: "areas/areaCarrerasSede",
        mete: {
            requiresAuth: true
        }
    },
    {
        path: "/ponderables/",
        name: "Ponderables",
        view: "ponderables/index",
        meta: {
            requieresAuth: true
        }
    },
    {
        path: "/universidad_recomendadas/",
        name: "UniversidadRecomendadas",
        view: "universidad_recomendadas/UniversidadRecomendadas",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/solicitud_informaciones/",
        name: "SolicitudInformaciones",
        view: "solicitud_informaciones/index",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/carreraSede/:id",
        name: "CarreraSede",
        view: "universidades/carreraSede",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/sedes/:id/carreras",
        name: "SedesCarreraSedes",
        view: "universidades/carreraSedes",
        meta: {
            requiresAuth: true
        }
    },

    {
        path: "/universidades",
        name: "Universidades",
        view: "universidades/index",
        mete: {
            requiresAuth: true
        }
    },
    {
        path: "/universidades/:id/sedes",
        name: "UniversidadSedes",
        view: "universidades/sedes",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/carreras",
        name: "Carreras",
        view: "carreras/Carreras",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/login",
        name: "Login",
        view: "usuarios/Login",
        meta: {
            guest: true
        }
    },
    {
        path: "/registro",
        name: "Registro",
        view: "usuarios/Registro",
        meta: {
            guest: true
        }
    },
    {
        path: "/home",
        name: "Home",
        view: "Home",
        meta: {
            requiresAuth: true
        }
    },
    // venían del template
    {
        path: "/dashboard",
        // Relative to /src/views
        view: "template/Dashboard",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/user-profile",
        name: "User Profile",
        view: "template/UserProfile",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/table-list",
        name: "Table List",
        view: "template/TableList",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/typography",
        view: "template/Typography",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/icons",
        view: "template/Icons",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/maps",
        view: "template/Maps",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/notifications",
        view: "template/Notifications",
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/upgrade",
        name: "Upgrade to PRO",
        view: "template/Upgrade",
        meta: {
            requiresAuth: true
        }
    }
]

export default rutas
